import { notification } from 'antd';

export const openNotificationWithIcon = (
  type: 'error' | 'success' | 'info' | 'warning',
  message: string,
  description: string,
): void => {
  notification[type]({
    message,
    description,
    duration: 10,
  });
};
